export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.31-1159.22",
  commitId: "0ded572e5fb0ade5403229a41c85ce88e07cce12",
  commitTime: "2026-07-31T11:59:22.000Z",
});
